import { createFileRoute, redirect } from '@tanstack/react-router'
import { Layout } from '@/shared/components/Layout'
import { FEATURES } from '@/shared/lib/featureFlags'
import { MessageSquareDiff, ClipboardList } from 'lucide-react'
import { Link } from '@tanstack/react-router'
import { useAuthStore } from '@/shared/store/authStore'

const MODULE_CARDS = [
  {
    key: 'messageRedactor' as const,
    label: 'Message Redactor',
    description: 'Polish and redact messages with AI. Tone, audience, and format controls. Word-level diff.',
    href: '/dashboard/message-redactor',
    icon: <MessageSquareDiff className="h-6 w-6" />,
  },
  {
    key: 'jiraToolbelt' as const,
    label: 'Jira Toolbelt',
    description: 'Turn draft notes into formatted Jira user stories, PR descriptions, and more.',
    href: '/dashboard/jira-toolbelt',
    icon: <ClipboardList className="h-6 w-6" />,
  },
]

function DashboardHome() {
  const enabledCards = MODULE_CARDS.filter((m) => FEATURES[m.key])

  return (
    <Layout>
      <div className="p-6 space-y-6">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Dashboard</h1>
          <p className="text-muted-foreground text-sm mt-1">Your personal tools</p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {enabledCards.map((card) => (
            <Link
              key={card.key}
              to={card.href}
              className="group flex flex-col gap-3 rounded-lg border bg-card p-5 transition-colors hover:bg-accent/50"
            >
              <div className="flex items-center gap-3">
                <div className="rounded-md bg-primary/10 p-2 text-primary">
                  {card.icon}
                </div>
                <h2 className="font-semibold">{card.label}</h2>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {card.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export const Route = createFileRoute('/dashboard/')({
  beforeLoad: () => {
    const { session, loading } = useAuthStore.getState()
    if (!loading && !session) {
      throw redirect({ to: '/login' })
    }
  },
  component: DashboardHome,
})
